module.exports = __webpack_public_path__ + "img/PrintempsParisKV.d3a95146.jpg";